import React, { useEffect, useState } from "react";
import { useLocation, Link ,useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import bg1 from "../../assets/images/bg/galleryVideo.jpg";
import bg from "../../assets/images/bg/galleryVideo-m.jpg";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import { firestore } from "../../Config/FbConfig";

const ITEMS_PER_PAGE = 6; // Number of items per page

export default function VideoList() {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [Blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const matchedItems = Blog?.filter(
    (item) => item.Categories === state?.category
  );
  const [currentPage, setCurrentPage] = useState(1); // Current page state

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchBlogData = async () => {
      setLoading(true);
      try {
        const docRef = doc(firestore, "Other", "OtherGalleryVideo");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = Object.entries(docSnap.data()).map(([key, value]) => ({
            Id: key,
            ...value,
          }));
          const sortedData = data.sort((a, b) => a.Priority - b.Priority);
          setBlog(sortedData);
          setNoData(sortedData.length === 0);
        } else {
          setBlog([]);
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching videos: ", error);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogData();
  }, []);


  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = matchedItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(matchedItems.length / ITEMS_PER_PAGE);

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: isMobile ? "2rem" : "",
        }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title text-white title-dark">
                  Gallery Videos
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  A play is not just words on a page; it's life unfolding in
                  real time, a shared breath between performer and audience.
                </p>
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Gallery Videos
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ marginBottom: "1.5rem" }}>
        <div className="container">
          {loading ? (
            <div className="text-center">
              <h5>Loading...</h5>
            </div>
          ) : noData ? (
            <div className="text-center">
              <h5>No Videos Available</h5>
            </div>
          ) : (
            <>
              <div>
                <h3
                  style={{
                    textTransform: "capitalize",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "1.5rem",
                  }}
                >
                  {state?.category}
                </h3>
              </div>
              <div style={{ marginBottom: "1.5rem" }}>
                <button
                  onClick={() => {
                    navigate("/gallery-videos");
                  }}
                  style={{ backgroundColor: "#B9B568", border: "#B9B568" }}
                  className="btn btn-primary"
                >
                  Go Back
                </button>
              </div>
              <div className="row">
                {currentItems?.map((items, index) => {
                  const embedUrl =
                    "https://www.youtube.com/embed/" + items.Link.split("=")[1];
                  return (
                    <div
                      className="col-lg-4 col-md-6 col-12 mb-4 pb-2"
                      key={index}
                    >
                      <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                        <iframe
                          width="100%"
                          height="220"
                          src={embedUrl}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "1rem",
                          textTransform: "capitalize",
                          fontSize: "18px",
                          fontWeight: 500,
                        }}
                        className="justify six-line-truncate"
                      >
                        {items.Header}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div  className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination">
                    {Array.from({ length: totalPages }, (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          onClick={() => paginate(index + 1)}
                          style={{backgroundColor:"#B9B568"}}
                          className="page-link"
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </section>
      <Footer />
      <ScrollTop />
    </>
  );
}
